/* global toggleMenu, Sentry */

// Function to fetch a section's HTML using the Section Rendering API

function fetchSection(sectionId) {
  return new Promise((resolve, reject) => {
    fetch(`${window.Shopify.routes.root}?sections=${sectionId}`)
      .then((response) => response.json())
      .then((data) => {
        resolve(data[sectionId]);
      })
      .catch((error) => {
        Sentry.captureException(error);
        reject(error);
      });
  });
}

// All the things on the page we update when cart contents change

function cartUpdated() {
  return new Promise((resolve, reject) => {
    fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        // Update cart count
        const cartCountElement = document.getElementById('cart-count');
        cartCountElement.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'item' : 'items'}`;

        // Update cart totals
        const subtotalElement = document.getElementById('cart-subtotal');
        subtotalElement.textContent = `$${(cart.total_price / 100).toFixed(2)}`;

        // Update checkout button
        const checkoutButton = document.getElementById('checkout-button');
        checkoutButton.disabled = cart.item_count === 0;

        // Update body data attribute
        document.body.setAttribute(
          'data-cart',
          cart.item_count > 0 ? 'filled' : 'empty',
        );

        // Fetch and update cart contents
        return fetchSection('cart-contents');
      })
      .then((innerHTML) => {
        const cartContentsContainer = document.getElementById('cart-contents');
        cartContentsContainer.innerHTML = innerHTML;
        resolve();
      })
      .catch((error) => {
        Sentry.captureException(error);
        reject(error);
      });
  });
}

// Handle add/remove cart events

document.addEventListener('DOMContentLoaded', function () {
  async function handleCartAction(event) {
    event.preventDefault();

    // Clear any existing cart messages
    cartMessage('');

    const cartForms = document.querySelectorAll('form.add-to-cart');
    const form = event.target.closest('form');
    const formData = new FormData(form);
    const productId = Number(formData.get('id'));
    const productName = formData.get('title');
    const action = form.getAttribute('action');
    const url =
      window.Shopify.routes.root +
      (action.includes('add') ? 'cart/add.js' : 'cart/change.js');

    // Check if item is already in the cart

    if (action.includes('add')) {
      const isInCart = await cartContainsProduct(productId);

      if (isInCart) {
        cartMessage(
          `<p class="error">${productName} is already in the cart.</p>`,
        );
        toggleMenu('cart');
        cartForms.forEach((button) => {
          button.classList.remove('adding');
        });
        return;
      }
    }

    // Update the cart

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
      },
    })
      .then((response) => response.json())
      .then((data) => {
        return cartUpdated();
      })
      .then(() => {
        if (action.includes('add')) {
          toggleMenu('cart');
          cartForms.forEach((button) => {
            button.classList.remove('adding');
          });
        }
        resetBundleQuantities();
      })
      .catch((error) => {
        if (action.includes('add')) {
          Sentry.captureException(error);
        } else {
          Sentry.captureException(error);
        }
      });
  }

  // Use event delegation because cart items can be added dynamically

  document.body.addEventListener('submit', function (event) {
    if (event.target.matches('form[action="/cart/add"]')) {
      event.target.classList.add('adding');
      handleCartAction(event);
    } else if (event.target.matches('form[action="/cart/change"]')) {
      handleCartAction(event);
    }
  });
});

// Determine if a product is already in the cart

async function cartContainsProduct(productId) {
  try {
    const response = await fetch(window.Shopify.routes.root + 'cart.js', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Network failed');
    }

    const cart = await response.json();
    return cart.items.some((item) => item.id === productId);
  } catch (error) {
    Sentry.captureException(error);
    return false;
  }
}

// Write something in the cart messages element

function cartMessage(message) {
  const cartMessages = document.getElementById('cart-messages');
  cartMessages.innerHTML = message;
}

// Change label on remove button action

document.body.addEventListener('click', function (event) {
  if (event.target.classList.contains('remove-from-cart')) {
    event.target.textContent = 'removing';
  }
});

// Set bundle form to exclude items already in the cart

async function resetBundleQuantities() {
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) throw new Error('Network failed');

    const cart = await response.json();
    const cartItemIds = new Set(cart.items.map((item) => item.id));

    const form = document.getElementById('bundle-add-to-cart');
    if (form) {
      form.querySelectorAll('input[name="items[][id]"]').forEach((input) => {
        const quantityInput = input.nextElementSibling;
        if (quantityInput && quantityInput.name === 'items[][quantity]') {
          quantityInput.value = cartItemIds.has(Number(input.value))
            ? '0'
            : '1';
        }
      });
    }
  } catch (error) {
    Sentry.captureException(error);
  }
}

resetBundleQuantities();
